<template>
  <b-row>
    <b-col md="12">
      <h5>Your Company </h5>
    </b-col>
    <b-col md="6">
      <small class="text-muted">{{ company.name }}</small>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BMedia,
  BAvatar,
  BLink,
  BButton,
} from 'bootstrap-vue';
import {ValidationProvider} from "vee-validate";

import {getQBCompanyInfo} from "@/api/company";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BMedia,
    BAvatar,
    BLink,
    BButton,

    ValidationProvider
  },
  props: {
    company: Object
  },
  created() {
    this.loadCompanyName()
  },
  methods: {
    loadCompanyName(){
      this.$emit('update:loading', true)
      getQBCompanyInfo(this.company.id).then(response => {
        console.log(response)

        this.company.name = response.CompanyInfo.CompanyName

        this.$set(this.company, 'name', this.company.name)

        this.$emit('update:loading', false)
      })
    }
  }
}
</script>
